import { stringEnum } from 'common/utils/objects';

export enum ProductTypes {
	RENTAL = 'rental',
	ACCESS = 'access',
	/**
	 * @deprecated The "service" product type is no longer used, but kept here
	 * because it may still exist in some old documents.
	 *
	 * Existing products and orders with this service type should be considered as "rental",
	 * or migrated to that.
	 */
	SERVICE = 'service',
}

export const UnitSystems = stringEnum(['METRIC', 'US', 'UK']);

export type UnitSystemType = keyof typeof UnitSystems;

export const UserDetailNames = stringEnum([
	'height',
	'weight',
	'shoeSize',
	'experienceLevel',
	'age',
	'stance',
]);

export type UserDetailName = keyof typeof UserDetailNames;

export const SizeChart = stringEnum(['MEN', 'WOMEN', 'KIDS', 'ADULTS']);

export type SizeChartType = keyof typeof SizeChart;
